import { activities } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectActivitySchema = createSelectSchema(activities)
export const insertActivitySchema = createInsertSchema(activities)
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    userId: true, // userId is auto-injected from authenticated user context
  })
  .extend({
    metadata: z.record(z.unknown()).optional(),
  })

export const updateActivitySchema = insertActivitySchema.partial()

export const selectActivityWithUserSchema = selectActivitySchema.extend({
  user: z.object({
    id: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
  }),
})

export type Activity = z.infer<typeof selectActivitySchema>
export type ActivityWithUser = z.infer<typeof selectActivityWithUserSchema>
export type CreateActivity = z.infer<typeof insertActivitySchema>
export type UpdateActivity = z.infer<typeof updateActivitySchema>
